/**
 * 防抖函数：在指定延迟时间内，多次触发只会执行最后一次
 * @param fn 需要防抖的函数
 * @param delay 延迟时间（毫秒）
 * @returns 包装后的防抖函数
 */
export const debounce = <T extends (...args: any[]) => any>(fn: T, delay: number): ((...args: Parameters<T>) => void) => {
  let timer: any = null

  return (...args: Parameters<T>): void => {
    // 如果已有定时器，清除它
    if (timer) {
      clearTimeout(timer)
    }

    // 设置新的定时器
    timer = setTimeout(() => {
      fn(fn(...args))
      timer = null // 执行后清空定时器引用
    }, delay)
  }
}

// 方式2：自己实现 debounce（无需额外依赖）
export const newDebounce = (fn: any, delay: number) => {
  let timer: number | null = null
  return function (this: any, ...args: any[]) {
    if (timer) clearTimeout(timer)
    timer = setTimeout(() => {
      fn.apply(this, args)
    }, delay)
  }
}

/**
 * 格式化输入值：限制为0-99的整数
 * @param value 输入的原始值
 * @returns 格式化后的字符串
 */
export const formatNumber = (value: number | string): number | string => {
  // 处理空值
  if (!value && value !== 0) return ''
  // 转换为数字
  let num = Number(value)
  // 处理非数字情况
  if (isNaN(num)) return ''
  // 取整数部分
  num = Math.floor(num)
  // 限制范围0-99
  if (num < 0) num = 0
  if (num > 99) num = 99

  // 返回字符串形式（确保显示正确）
  return Number(num)
}
